/* eslint-disable no-param-reassign */
import Sonda from '@bit/gerenciatd.utils.front-sonda';
import {
  moduloBannerSolucionesDigitales,
  moduloIntroduccionSolucionesDigitales,
  moduloResultadosPorcentajesSolucionesDigitales,
  moduloRecomendacionesSolucionesDigitales,
  moduloVentajasSolucionesDigitales,
  moduloVentaCruzadaSolucionesDigitales,
  moduloSolucionesSolucionesDigitales,
  moduloFraseDestacada,
  moduloNoTePierdasNadaSolucionesDigitales,
  moduloSubCabeceraSolucionesDigitales,
  moduloVideoBannerSolucionesDigitales,
  moduloVideoInternoSolucionesDigitales,
  moduloCarrousel,
  moduloMenuPrincipal,
  moduloStandardBanner,
  moduloBannerHablaConExperto,
  moduloFAQ,
  moduloFourKeys,
  moduloDescargas,
  moduloCarousel,
  moduloPriceCards,
  moduloFixedBar,
  moduloServiceAccess,
  moduloOfertaEmpresas,
  moduloClickBox,
} from '../../utils/soluciones.utils';
import { createSondaContext } from '../../utils/contextUtils';


/**
 * Normaliza los fusiones que vienen desde catálogo a una estructura válida
 * @param {Object[]} solucionesList - lista de los fusiones que viene desde catálogo
 * @returns {Object[]} - lista de fusiones normalizados
 */
export const normalizeSoluciones = (solucionesList) => {
  const context = createSondaContext('empresas');
  const sonda = new Sonda({
    processName: 'normalizeProductsOfFusion',
    context,
    filePath: 'sagas/normalizers/fusion',
  });
  if (!solucionesList) {
    sonda.severalMessage({ info: 'solucionesList no exist' });
    return null;
  }
  let productsToArray = [];

  if (!Array.isArray(solucionesList)) {
    solucionesList = [solucionesList];
  }

  try {
    // Aqui lo que hacemos es recorrer la lista de modulos, y pasarlos por sus normalizadores
    productsToArray = solucionesList.reduce((arr, currentProduct) => {
      Object.values(currentProduct.data.fields).map((item) => {
        const copyItems = { ...item };
        switch (item.name) {
          case 'MODULO_BANNER_SOLUCIONES_DIGITALES':
            item.fields = moduloBannerSolucionesDigitales(item.fields);
            break;
          case 'MODULO_VIDEO_SOLUCIONES_DIGITALES':
            item.fields = moduloVideoBannerSolucionesDigitales(item.fields);
            break;
          case 'MODULO_INTRODUCCION_SOLUCIONES_DIGITALES':
            item.fields = moduloIntroduccionSolucionesDigitales(item.fields);
            break;
          case 'MODULO_RESULTADOS_PORCENTAJES_SOLUCIONES_DIGITALES':
            item.fields = moduloResultadosPorcentajesSolucionesDigitales(item.fields);
            break;
          case 'MODULO_RECOMENDACIONES_SOLUCIONES_DIGITALES':
            item.fields = moduloRecomendacionesSolucionesDigitales(item.fields);
            break;
          case 'MODULO_VENTAJAS_SOLUCIONES_DIGITALES':
            item.fields = moduloVentajasSolucionesDigitales(item.fields);
            break;
          case 'MODULO_VENTA_CRUZADA_SOLUCIONES_DIGITALES':
          case 'MODULO_OTROS_PRODUCTOS_SOLUCIONES_DIGITALES':
            item.fields = moduloVentaCruzadaSolucionesDigitales(item.fields);
            break;
          case 'MODULO_PRICE_CARDS':
            item.fields = moduloPriceCards(item.fields);
            break;
          case 'MODULO_SOLUCIONES_SOLUCIONES_DIGITALES':
            item.fields = moduloSolucionesSolucionesDigitales(item.fields);
            break;
          case 'MODULO_FRASE_DESTACADA_SOLUCIONES_DIGITALES':
            item.fields = moduloFraseDestacada(item.fields);
            break;
          case 'MODULO_NO_TE_PIERDAS_NADA_SOLUCIONES_DIGITALES':
            item.fields = moduloNoTePierdasNadaSolucionesDigitales(item.fields);
            break;
          case 'MODULO_CABECERAS_SOLUCIONES_DIGITALES':
            item.fields = moduloSubCabeceraSolucionesDigitales(item.fields);
            break;
          case 'MODULO_CARROUSEL_SOLUCIONES_DIGITALES':
            item.fields = moduloCarrousel(item.fields);
            break;
          case 'MODULO_VIDEO_INTERNO_SOLUCIONES_DIGITALES':
            item.fields = moduloVideoInternoSolucionesDigitales(item.fields);
            break;
          case 'MODULO_MENU_PRINCIPAL':
            item.fields = moduloMenuPrincipal(item.fields);
            break;
          case 'MODULO_BANNER_PRINCIPAL':
            item.fields = moduloStandardBanner(item.fields);
            item.fixedBar = moduloFixedBar(copyItems.fields)
            break;
          case 'MODULO_BANNER_CTA':
            item.fields = moduloBannerHablaConExperto(item.fields);
            break;
          case 'FAQS_PREGUNTAS_FRECUENTES':
            item.fields = moduloFAQ(item);
            break;
          case 'MODULO_DESCARGA_PDF':
            item.fields = moduloDescargas(item.fields);
            break;
          case 'MODULO_CLAVES_LISTADO':
            item.fields = moduloFourKeys(item);
            break;
          case 'MODULO_CARROSUEL_FRASE_SLIDER':
            item.fields = moduloCarousel(item.fields);
            break;
          case 'MODULO_ACCESO_SERVICIO':
            item.fields = moduloServiceAccess(item.fields);
            break;
          case 'MODULO_BANNER_INTERNO':
            item.fields = moduloClickBox(item.fields);
            break;
          case 'SECCIONES_OFERTAS_EMPRESAS':
            item.fields = moduloOfertaEmpresas(item.fields)
            break;
          default:
            return null;
        }
        return item;
      });

      arr = [...arr, currentProduct];
      return arr;
    }, []);
    console.log(productsToArray);
    return productsToArray;
  } catch (error) {
    console.log({ error });
    sonda.severalMessage({ error });
    return null;
  }
};
